/*
 * This file is automatically generated. Please do not edit it directly.
 * If you need to update it, edit `tools/generate-motion-tokens.ts` and
 * run `pay js:run generate:tokens`.
 */export const duration = {
  default: 0.15,
  instant: 0,
  xshort: 0.05,
  short: 0.1,
  medium: 0.15,
  long: 0.3,
  xlong: 0.5
};
export const easing = {
  default: [0, 0.09, 0.4, 1],
  smooth: "easeInOut",
  enter: [0, 0, 0.4, 1],
  exit: [0.4, 0, 1, 1],
  continuous: "linear"
};
export const translate = {
  subtle: 2,
  regular: 8,
  sheet: "100%"
};
export const spring = {
  gentle: {
    type: "spring",
    stiffness: 120,
    damping: 14
  },
  snappy: {
    type: "spring",
    stiffness: 300,
    damping: 20
  },
  bouncy: {
    type: "spring",
    stiffness: 400,
    damping: 10
  }
};
export const stagger = {
  xshort: 0.03,
  short: 0.05,
  medium: 0.08
};
export const scale = {
  enter: 0.95,
  subtle: 0.99,
  fullsize: 1,
  pressed: 0.98,
  hover: 1.02
};
export const transition = {
  default: {
    duration: 0.15,
    ease: [0, 0.09, 0.4, 1]
  },
  smooth: {
    duration: 0.15,
    ease: "easeInOut"
  },
  enter: {
    duration: 0.15,
    ease: [0, 0, 0.4, 1]
  },
  exit: {
    duration: 0.15,
    ease: [0.4, 0, 1, 1]
  },
  continuous: {
    duration: 0.15,
    ease: "linear"
  },
  gentle: {
    type: "spring",
    stiffness: 120,
    damping: 14
  },
  snappy: {
    type: "spring",
    stiffness: 300,
    damping: 20
  },
  bouncy: {
    type: "spring",
    stiffness: 400,
    damping: 10
  }
};